import { IQPlayerData } from '../interfaces';

export const formatData = (data: IQPlayerData|null) : IQPlayerData|null => {
    if(!data?.presets) return null;

    for(const playListItem of data.presets) {
        playListItem.audioSources = [];
        playListItem.gainNodes = [];
        playListItem.audioBuffers = [];
    }

    return data;
};

export const getAudioFilterIndex = (isBypass: boolean, isDelta: boolean) : number => {
    if(isDelta) return 2;
    if(isBypass) return 1;
    return 0;
};

export const getVideoFilterIndex = (isBypass: boolean, isDelta: boolean) : number => {
    if(isDelta) return 2;
    if(isBypass) return 0;
    return 1;
};